import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { INGESTION_POLICIES } from '../types';

type FiltersContextState = {
  ingestionPolicyFilter: INGESTION_POLICIES;
  setIngestionPolicyFilter: (ingestionPolicy: INGESTION_POLICIES) => void;
  searchQuery: string;
  setSearchQuery: (Query: string) => void;
  startDate: string;
  setStartDate: (startDate: string) => void;
  endDate: string;
  setEndDate: (endDate: string) => void;
  preset: string;
  setPreset: (preset: string) => void;
};

export const defaultState = {
  ingestionPolicyFilter: INGESTION_POLICIES.ALL,
  setIngestionPolicyFilter: noop,
  searchQuery: '',
  setSearchQuery: noop,
  startDate: '',
  setStartDate: noop,
  endDate: '',
  setEndDate: noop,
  preset: '',
  setPreset: noop,
};

export const FiltersContext = createContext<FiltersContextState>(defaultState);

export const useFiltersContext = () => useContext(FiltersContext);
